// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._122CxRxAvGpnvACHDCPmSI {\n  background-color: #fff;\n}\n\n._2kvVFgwMeauKsd5e0aGl-n {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: .25rem;\n  color: #fff;\n}\n\n._1A5wO-RF3kXBi2GwKW1xFb {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1em;\n  color: #bdbdbd;\n}\n", ""]);
// Exports
exports.locals = {
	"collection": "_122CxRxAvGpnvACHDCPmSI",
	"cell": "_2kvVFgwMeauKsd5e0aGl-n",
	"noCells": "_1A5wO-RF3kXBi2GwKW1xFb"
};
module.exports = exports;
